"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("../Input"));

function InputControl(_ref) {
  var onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      props = (0, _objectWithoutProperties2.default)(_ref, ["onChange", "onBlur"]);
  var onChangeInput = (0, _react.useCallback)(function (e) {
    var value = e && e.target ? e.target.value : '';
    onChange && onChange(props.name, value);
  }, [onChange, props.name]);
  var onBlurInput = (0, _react.useCallback)(function (e) {
    var value = e && e.target ? e.target.value : '';
    onBlur && onBlur(props.name, value);
  }, [onBlur, props.name]);
  return /*#__PURE__*/_react.default.createElement(_Input.default, (0, _extends2.default)({}, props, {
    onChange: onChangeInput,
    onBlur: onBlurInput
  }));
}

InputControl.defaultProps = {};
process.env.NODE_ENV !== "production" ? InputControl.propTypes = {
  onChange: _propTypes.default.func
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(InputControl);

exports.default = _default;